module.exports = __webpack_public_path__ + "static/media/bookings-selected.4279e45d.svg";